import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { Drawer, Descriptions, Divider, Button, Row, Col, Table, Typography, Spin, Image, Space, Tooltip } from 'antd'
import { EditOutlined } from '@ant-design/icons';
import { checkPermission } from '../../utils/permission';
import NumberFormat from 'react-number-format';
import ReactHtmlParser from 'react-html-parser';
import { isMobile } from 'react-device-detect';
import ProductReceiptImportForm from './ProductReceiptImportForm';
import ProductDetail from './../product/ProductDetail';
import { isValidDate, ConvertProductReceiptImportType, renderVatStatusTag } from '../../utils/helpers';

// actions
import { getSpecificProductReceiptImport } from '../../redux/actions/ProductReceiptImportActions';
import { getSpecificProduct } from '../../redux/actions/ProductActions';

const { Text } = Typography;

class ProductReceiptImportDetail extends Component {
    constructor() {
        super();
        this.state = {
            isOpenEditForm: false,
            currentItemEdit: null,
            isOpenProductDetail: false,
            currentProduct: null,
            currentProductId: null
        };
    }

    handleCancel() {
        this.props.onCancel();
    }

    toggleOpenEditForm(isOpenEditForm, currentItemEdit = null) {
        this.setState({ isOpenEditForm: isOpenEditForm, currentItemEdit: currentItemEdit });
    }

    onEdit(id) {
        this.props.getSpecificProductReceiptImport(id).then(res => {
            this.toggleOpenEditForm(true, res);
        })
    }

    toggleOpenProductDetail(isOpenProductDetail, data = null) {
        this.setState({ isOpenProductDetail: isOpenProductDetail, currentProduct: data });
    }

    onProductDetail(id) {
        this.setState({ currentProductId: id })
        this.props.getSpecificProduct(id).then(res => {
            this.toggleOpenProductDetail(true, res);
        })
    }

    render() {
        var { isOpenEditForm, isLoading, currentItemEdit, isOpenProductDetail, currentProduct, currentProductId } = this.state;
        var { visible, currentItem, loadingDetail } = this.props;
        //console.log("currentItemDetail: ", currentItem)

        var columns = [
            {
                title: "STT",
                dataIndex: "stt",
                width: "40px",
                align: 'center',
                render: (text, record, index) => index + 1
            },
            {
                title: "ID",
                dataIndex: "id",
                width: "40px",
                align: 'center'
            },
            {
                title: "Tên sản phẩm",
                dataIndex: "name",
                //width: "180px",
                render: (text, record) => {
                    if (record.name) {
                        if (checkPermission('product', 'detail')) {
                            return (
                                <Tooltip title="Xem chi tiết sản phẩm" placement="right">
                                    <div className='alink item-action-btn' onClick={() => this.onProductDetail(record.id)}>
                                        {record.name}
                                    </div>
                                </Tooltip>
                            )
                        } else {
                            return (
                                <>{record.name}</>
                            )
                        }
                    } else {
                        return <>N/A</>
                    }
                }
            },
            {
                title: "Kho",
                dataIndex: "warehouse_name",
                width: "120px"
            },


            // {
            //     title: "Thành tiền",
            //     dataIndex: "amount",
            //     width: "100px",
            //     render: (text, record) => {
            //         return (
            //             <NumberFormat value={text} displayType={'text'} suffix="đ" thousandSeparator={true} />
            //         )
            //     }
            // },
            {
                title: `SL chờ VAT`,
                dataIndex: 'qty_vat_pending',
                key: 'qty_vat_pending',
                width: "110px",
                sorter: true
            },
            {
                title: "SL có VAT",
                dataIndex: "qty_vat",
                width: "100px"
            },

            {
                title: "SL chưa VAT",
                dataIndex: "qty_no_vat",
                width: "100px"
            },

            {
                title: "SL Tổng",
                dataIndex: "quantity",
                width: "100px"
            },
            {
                title: "Giá nhập",
                dataIndex: "regular_price",
                width: "100px",
                render: (text, record) => {
                    return (
                        <NumberFormat value={text} displayType={'text'} suffix="đ" thousandSeparator={true} />
                    )
                }
            },
            {
                title: "Đơn vị tính",
                dataIndex: "unit",
                width: "90px"
            },
            {
                title: "Tình trạng",
                dataIndex: "product_status_name",
                width: "90px"
            },
            // {
            //     title: "Trạng thái VAT",
            //     dataIndex: "vat_status",
            //     width: "120px",
            //     render: (text, record) => {
            //         return (
            //             <>{renderVatStatusTag(text)}</>
            //         )
            //     }
            // },
            {
                title: "Hạn sử dụng",
                dataIndex: "expiry_date",
                width: "110px",
                render: (text, record) => {
                    return (
                        <div>{isValidDate(text, false)}</div>
                    )
                }
            },
            {
                title: "Ghi chú",
                dataIndex: "note",
                width: "200px"
            }
        ];

        return (
            <>
                <Drawer
                    visible={visible}
                    title={`Chi tiết phiếu: ${currentItem?.name}`}
                    onClose={() => this.handleCancel()}
                    maskClosable={false}
                    width={isMobile ? '100%' : '98%'}
                    extra={
                        checkPermission('product_receipt_import', 'update') ? (
                            <Button type="primary" onClick={() => this.onEdit(currentItem?.id)} icon={<EditOutlined />}>Sửa</Button>
                        ) : null
                    }
                >
                    {visible ? (
                        <div>
                            <Spin tip="Loading..." spinning={loadingDetail}>
                                <Row gutter={16}>
                                    <Col xs={24} md={24}>
                                        <Divider orientation="left" orientationMargin="0">
                                            Thông tin sản phẩm
                                        </Divider>
                                        <Row gutter={16}>
                                            <Col xs={24} md={24}>
                                                <Table
                                                    className='mt-2'
                                                    size='small'
                                                    rowKey='key'
                                                    tableLayout="auto"
                                                    columns={columns}
                                                    dataSource={currentItem?.items || []}
                                                    pagination={false}
                                                    loading={isLoading}
                                                    scroll={{
                                                        x: 'max-content'
                                                    }}
                                                />
                                            </Col>
                                        </Row>
                                        <Row justify="end" gutter={16} className='mt-4'>
                                            <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                <h5>Tổng tiền: <NumberFormat value={currentItem ? currentItem.total_amount : 0} displayType={'text'} suffix="đ" thousandSeparator={true} /></h5>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col xs={24} md={24}>
                                        <Divider orientation="left" orientationMargin="0">
                                            Thông tin phiếu
                                        </Divider>
                                        <div className='box-info'>
                                            <Row gutter={16}>
                                                <Col xs={24} md={24}>
                                                    <Descriptions size="small">
                                                        <Descriptions.Item label="Tên phiếu">
                                                            {currentItem ? currentItem.name : null}
                                                        </Descriptions.Item>
                                                    </Descriptions>
                                                    <Divider className="no-margin" />
                                                </Col>
                                                <Col xs={24} md={24}>
                                                    <Descriptions size="small">
                                                        <Descriptions.Item label="Mã phiếu">
                                                            {currentItem ? currentItem.code : null}
                                                        </Descriptions.Item>
                                                    </Descriptions>
                                                    <Divider className="no-margin" />
                                                </Col>
                                                <Col xs={24} md={24}>
                                                    <Descriptions size="small">
                                                        <Descriptions.Item label="Loại phiếu">
                                                            {ConvertProductReceiptImportType(currentItem?.type)}
                                                        </Descriptions.Item>
                                                    </Descriptions>
                                                    <Divider className="no-margin" />
                                                </Col>
                                                <Col xs={24} md={24}>
                                                    <Descriptions size="small">
                                                        <Descriptions.Item label="Kho">
                                                            {currentItem ? currentItem.warehouse_name : null}
                                                        </Descriptions.Item>
                                                    </Descriptions>
                                                    <Divider className="no-margin" />
                                                </Col>
                                                <Col xs={24} md={24}>
                                                    <Descriptions size="small">
                                                        <Descriptions.Item label="Nhà cung cấp">
                                                            {currentItem ? currentItem.supplier_name : null}
                                                        </Descriptions.Item>
                                                    </Descriptions>
                                                    <Divider className="no-margin" />
                                                </Col>
                                                <Col xs={24} md={24}>
                                                    <Descriptions size="small">
                                                        <Descriptions.Item label="Tổng tiền">
                                                            <NumberFormat value={currentItem ? currentItem.total_amount : null} displayType={'text'} suffix="đ" thousandSeparator={true} />
                                                        </Descriptions.Item>
                                                    </Descriptions>
                                                    <Divider className="no-margin" />
                                                </Col>
                                                <Col xs={24} md={24}>
                                                    <div><strong>Ghi chú:</strong></div>
                                                    {currentItem ? ReactHtmlParser(currentItem.note) : null}
                                                    <Divider className="no-margin" />
                                                </Col>
                                                <Col xs={24} md={24} className='mt-2'>
                                                    <Descriptions size="small">
                                                        <Descriptions.Item label="Ngày nhập">
                                                            {isValidDate(currentItem.import_date, false)}
                                                        </Descriptions.Item>
                                                    </Descriptions>
                                                    <Divider className="no-margin" />
                                                </Col>
                                                <Col xs={24} md={24} className='mt-2'>
                                                    <Descriptions size="small">
                                                        <Descriptions.Item label="Ngày lập phiếu">
                                                            {isValidDate(currentItem.created_at)}
                                                        </Descriptions.Item>
                                                    </Descriptions>
                                                    <Divider className="no-margin" />
                                                </Col>
                                                <Col xs={24} md={24}>
                                                    <Descriptions size="small">
                                                        <Descriptions.Item label="Người lập">
                                                            {currentItem ? currentItem.created_user : null}
                                                        </Descriptions.Item>
                                                    </Descriptions>
                                                    <Divider className="no-margin" />
                                                </Col>
                                                <Col xs={24} md={24}>
                                                    <div className='mb-1 mt-2'>
                                                        <Text strong>Ảnh phiếu</Text>
                                                    </div>
                                                    <Image.PreviewGroup>
                                                        <Space wrap>
                                                            {
                                                                currentItem?.images.map((item, index) => {
                                                                    return (
                                                                        <Image
                                                                            key={index}
                                                                            width={50}
                                                                            height={50}
                                                                            src={item.src}
                                                                            style={{
                                                                                border: '1px solid #dedede',
                                                                                objectFit: 'cover',
                                                                                objectPosition: 'center',
                                                                            }}
                                                                        />
                                                                    )
                                                                })
                                                            }
                                                        </Space>
                                                    </Image.PreviewGroup>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                </Row>
                            </Spin>
                        </div>
                    ) : null}

                </Drawer>
                <ProductReceiptImportForm
                    visible={isOpenEditForm}
                    currentItem={currentItemEdit}
                    reloadData={() => this.props.reloadData()}
                    onCancel={() => this.toggleOpenEditForm(false)}
                />

                <ProductDetail
                    visible={isOpenProductDetail}
                    currentItem={currentProduct}
                    reloadData={() => this.onProductDetail(currentProductId)}
                    onCancel={() => this.toggleOpenProductDetail(false)}
                />
            </>
        )
    }
}
function mapStateToProps(state) {
    return {
        authUser: state.auth.authUser
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getSpecificProductReceiptImport: (id) => dispatch(getSpecificProductReceiptImport(id)),
        getSpecificProduct: (id) => dispatch(getSpecificProduct(id))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'ProductReceiptImportDetail' })(ProductReceiptImportDetail));
